export const START_FETCH_STOCKS = 'START_FETCH_STOCKS';

export const SET_FETCHED_STOCKS = 'SET_FETCHED_STOCKS';

export const START_FETCH_MORE_STOCKS = 'START_FETCH_MORE_STOCKS';

export const PREPEND_FETCHED_STOCKS = 'PREPEND_FETCHED_STOCKS';

export const APPEND_FETCHED_STOCKS = 'APPEND_FETCHED_STOCKS';

export const FETCH_STOCKS_ERROR = 'FETCH_STOCKS_ERROR';

export const START_FETCH_PAGINATED_STOCKS = 'START_FETCH_PAGINATED_STOCKS';

export const SET_FETCHED_PAGINATED_STOCKS = 'SET_FETCHED_PAGINATED_STOCKS';

// Filters of Stock Seaching
export const SET_FILTER = 'SET_FILTER';

export const UNSET_FILTER = 'UNSET_FILTER';

export const CHANGE_SORTING = 'CHANGE_SORTING';

// Highlight Stock Features
export const HIGHLIGHT_STOCK = 'HIGHLIGHT_STOCK';

export const SET_RECENT_VISITED = 'SET_RECENT_VISITED';

export const SET_FAVORITE = 'SET_FAVORITE';

export const SET_FAVORITE_2 = 'SET_FAVORITE_2';

export const SET_FETCHED_RECENT_VISITED = 'SET_FETCHED_RECENT_VISITED';

export const SET_FETCHED_FAVORITE = 'SET_FETCHED_FAVORITE';

export const SET_AUTO_SEARCH = 'SET_AUTO_SEARCH';

export const SET_PAGE_SIZE = 'SET_PAGE_SIZE';
